module.exports = "https://www.gc-qa.gnp.com.mx/6f9392746f0a9609f8874f185b875ad7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/flecha-izquierda.svg
// module id = 216
// module chunks = 0